// extracted by mini-css-extract-plugin
export var actionButton = "_ii-0";
export var actionMenuContainer = "_ii-i";
export var bubble = "_ii-2";
export var bubbleActionMenu = "_ii-j";
export var bubbleContext = "_ii-6";
export var bubbleItems = "_ii-7";
export var customer = "_ii-3";
export var divider = "_ii-8";
export var fileList = "_ii-9";
export var hiddenComment = "_ii-o";
export var infoAbove = "_ii-a";
export var internal = "_ii-4";
export var lightActionButton = "_ii-1";
export var link = "_ii-b";
export var merchant = "_ii-5";
export var message = "_ii-c";
export var profilePicture = "_ii-e";
export var quillToolbarContainer = "_ii-f";
export var senderDate = "_ii-g";
export var senderDateCustomer = "_ii-h";
export var senderName = "_ii-d";
export var time = "_ii-k";
export var uploadedImage = "_ii-l";
export var username = "_ii-m";
export var xsmall = "_ii-n";